const removeIsExistingCognitoUserFromLocalStorage = () => {
  localStorage.removeItem('anova_is_existing_cognito_user')
}

export default removeIsExistingCognitoUserFromLocalStorage
